(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5811],{

/***/ 25216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ state_of_personalization_report_2022; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(562);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(88958);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(1506);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/Hero/Hero.tsx










var copy = {
  heading: "The State of Personalization 2022",
  description: "Brought to you by Twilio Segment"
};
var Hero_button = {
  text: "Download the report",
  url: "https://segment.com/pdfs/State-of-Personalization-Report-Twilio-Segment-2022.pdf"
};
var TRACKING_EVENT = "Content Downloaded";

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeForm, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            resourceType: "report",
            buttonText: Hero_button.text,
            successButtonText: Hero_button.text,
            additionalTrackEvent: TRACKING_EVENT,
            buttonUrl: Hero_button.url,
            successMessageAppearance: "twilioLight",
            customFormIdentifier: "state-of-personalization-report",
            enableJobTitleField: true
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "640",
            height: "476",
            src: (Hero_2x_default()),
            alt: "The State of Personalization",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e13ptnt64"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e13ptnt63"
} : 0)(recipes_Hero/* Wrapper */.im, "{justify-content:unset;}" + ( true ? "" : 0));

var heroColumnStyles = function heroColumnStyles(theme) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("max-width:568px;", theme.breakpoints.up("lg"), "{max-width:unset;}" + ( true ? "" : 0),  true ? "" : 0);
};

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e13ptnt62"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return heroColumnStyles(theme);
}, ";text-align:left;" + ( true ? "" : 0));

var HeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e13ptnt61"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return heroColumnStyles(theme);
}, ";justify-items:unset;" + ( true ? "" : 0));

var StyledHeroRecipeForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Form */.l0,  true ? {
  target: "e13ptnt60"
} : 0)("max-width:100%;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.between("sm", "md");
}, "{max-width:488px;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/GettingStarted/GettingStarted.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var GettingStarted = function GettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Build your personalization strategy with Twilio Segment" : _ref$description;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          variant: "outlined",
          tag: "a",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    })
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fhkjos2"
} : 0)( true ? {
  name: "1fhwumf",
  styles: "overflow-y:auto;overflow-x:hidden;padding-top:80px;padding-bottom:80px"
} : 0);

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fhkjos1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fhkjos0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/TrendSection.tsx


function TrendSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var TrendSection = function TrendSection(_ref) {
  var order = _ref.order,
      heading = _ref.heading,
      caption = _ref.caption,
      pngSrc2x = _ref.pngSrc2x,
      webpSrc = _ref.webpSrc,
      webpSrc2x = _ref.webpSrc2x;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UppercaseCopyTextOverline, {
          children: ["Trend ", order]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: heading
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
          type: "image/webp",
          srcSet: "".concat(webpSrc, ", ").concat(webpSrc2x, " 2x")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
          width: "640",
          height: "280",
          src: pngSrc2x,
          alt: caption,
          loading: "lazy"
        })]
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1jjdx8h3"
} : 0)(Section/* Wrapper */.im, "{justify-content:unset;margin:0;padding:40px 0;row-gap:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{row-gap:40px;}}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1jjdx8h2"
} : 0)( true ? {
  name: "18txy2g",
  styles: "height:100%;display:flex;flex-direction:column;justify-content:center"
} : 0);

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1jjdx8h1"
} : 0)( true ? {
  name: "lno2ya",
  styles: "justify-items:start"
} : 0);

var UppercaseCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e1jjdx8h0"
} : 0)( true ? {
  name: "50zrmy",
  styles: "text-transform:uppercase"
} : 0);

/* harmony default export */ var KeyFindings_TrendSection = (TrendSection);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend01Visual.png
var Trend01Visual = __webpack_require__(96950);
var Trend01Visual_default = /*#__PURE__*/__webpack_require__.n(Trend01Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend01Visual@2x.png
var Trend01Visual_2x = __webpack_require__(20870);
var Trend01Visual_2x_default = /*#__PURE__*/__webpack_require__.n(Trend01Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend01Visual.webp
var assets_Trend01Visual = __webpack_require__(49144);
var assets_Trend01Visual_default = /*#__PURE__*/__webpack_require__.n(assets_Trend01Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend01Visual@2x.webp
var assets_Trend01Visual_2x = __webpack_require__(67451);
var assets_Trend01Visual_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Trend01Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend02Visual.png
var Trend02Visual = __webpack_require__(16610);
var Trend02Visual_default = /*#__PURE__*/__webpack_require__.n(Trend02Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend02Visual@2x.png
var Trend02Visual_2x = __webpack_require__(65473);
var Trend02Visual_2x_default = /*#__PURE__*/__webpack_require__.n(Trend02Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend02Visual.webp
var assets_Trend02Visual = __webpack_require__(15355);
var assets_Trend02Visual_default = /*#__PURE__*/__webpack_require__.n(assets_Trend02Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend02Visual@2x.webp
var assets_Trend02Visual_2x = __webpack_require__(7098);
var assets_Trend02Visual_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Trend02Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend03Visual.png
var Trend03Visual = __webpack_require__(54748);
var Trend03Visual_default = /*#__PURE__*/__webpack_require__.n(Trend03Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend03Visual@2x.png
var Trend03Visual_2x = __webpack_require__(58827);
var Trend03Visual_2x_default = /*#__PURE__*/__webpack_require__.n(Trend03Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend03Visual.webp
var assets_Trend03Visual = __webpack_require__(94841);
var assets_Trend03Visual_default = /*#__PURE__*/__webpack_require__.n(assets_Trend03Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend03Visual@2x.webp
var assets_Trend03Visual_2x = __webpack_require__(28208);
var assets_Trend03Visual_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Trend03Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend04Visual.png
var Trend04Visual = __webpack_require__(47111);
var Trend04Visual_default = /*#__PURE__*/__webpack_require__.n(Trend04Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend04Visual@2x.png
var Trend04Visual_2x = __webpack_require__(44557);
var Trend04Visual_2x_default = /*#__PURE__*/__webpack_require__.n(Trend04Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend04Visual.webp
var assets_Trend04Visual = __webpack_require__(13334);
var assets_Trend04Visual_default = /*#__PURE__*/__webpack_require__.n(assets_Trend04Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend04Visual@2x.webp
var assets_Trend04Visual_2x = __webpack_require__(50932);
var assets_Trend04Visual_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Trend04Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend05Visual.png
var Trend05Visual = __webpack_require__(66752);
var Trend05Visual_default = /*#__PURE__*/__webpack_require__.n(Trend05Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend05Visual@2x.png
var Trend05Visual_2x = __webpack_require__(13721);
var Trend05Visual_2x_default = /*#__PURE__*/__webpack_require__.n(Trend05Visual_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend05Visual.webp
var assets_Trend05Visual = __webpack_require__(48299);
var assets_Trend05Visual_default = /*#__PURE__*/__webpack_require__.n(assets_Trend05Visual);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/assets/Trend05Visual@2x.webp
var assets_Trend05Visual_2x = __webpack_require__(64440);
var assets_Trend05Visual_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Trend05Visual_2x);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/data.ts




















var trends = [{
  order: "01",
  heading: "Personalization and ROI go hand in hand",
  caption: "Nearly half (49%) of consumers say they will likely become a repeat buyer after a personalized shopping experience with a retailer.",
  pngSrc: (Trend01Visual_default()),
  pngSrc2x: (Trend01Visual_2x_default()),
  webpSrc: (assets_Trend01Visual_default()),
  webpSrc2x: (assets_Trend01Visual_2x_default())
}, {
  order: "02",
  heading: "Investments in omnichannel are improving, but still have a long way to go",
  caption: "Only 35% of companies feel they are successfully achieving omnichannel personalization, up from 24% in 2021.",
  pngSrc: (Trend02Visual_default()),
  pngSrc2x: (Trend02Visual_2x_default()),
  webpSrc: (assets_Trend02Visual_default()),
  webpSrc2x: (assets_Trend02Visual_2x_default())
}, {
  order: "03",
  heading: "Businesses are future-proofing their personalization efforts with first-party data",
  caption: "37% of brands exclusively use first-party data to personalize customer experiences, a six percentage point increase compared to 2021.",
  pngSrc: (Trend03Visual_default()),
  pngSrc2x: (Trend03Visual_2x_default()),
  webpSrc: (assets_Trend03Visual_default()),
  webpSrc2x: (assets_Trend03Visual_2x_default())
}, {
  order: "04",
  heading: "Businesses seek balance in the personalization-privacy paradox",
  caption: "Just 40% of consumers say they trust brands to keep their personal data secure and use it responsibly.",
  pngSrc: (Trend04Visual_default()),
  pngSrc2x: (Trend04Visual_2x_default()),
  webpSrc: (assets_Trend04Visual_default()),
  webpSrc2x: (assets_Trend04Visual_2x_default())
}, {
  order: "05",
  heading: "The bar for personalization is getting higher",
  caption: "Less than half (47%) of companies personalize communications based on real-time customer behavior.",
  pngSrc: (Trend05Visual_default()),
  pngSrc2x: (Trend05Visual_2x_default()),
  webpSrc: (assets_Trend05Visual_default()),
  webpSrc2x: (assets_Trend05Visual_2x_default())
}];
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/KeyFindings/KeyFindings.tsx



var _excluded = ["order"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function KeyFindings_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var KeyFindings_copy = {
  heading: "Key findings"
};

var KeyFindings = function KeyFindings() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KeyFindings_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KeyFindings_StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_UppercaseCopyTextOverline, {
          tag: "h2",
          variant: "overline",
          children: KeyFindings_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: trends.map(function (_ref) {
        var order = _ref.order,
            trendProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_TrendSection, _objectSpread({
            order: order
          }, trendProps)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
        }, order);
      })
    })]
  });
};

var KeyFindings_UppercaseCopyTextOverline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Overline */.Lh,  true ? {
  target: "e1lfdzsk3"
} : 0)( true ? {
  name: "50zrmy",
  styles: "text-transform:uppercase"
} : 0);

var KeyFindings_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1lfdzsk2"
} : 0)(">", Section/* Wrapper */.im, "{row-gap:0;justify-content:unset;margin:0;padding-bottom:0;}" + ( true ? "" : 0));

var KeyFindings_StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1lfdzsk1"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1lfdzsk0"
} : 0)( true ? {
  name: "92375q",
  styles: "margin:25px 0 0"
} : 0);

/* harmony default export */ var KeyFindings_KeyFindings = (KeyFindings);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/Methodology/data.tsx
var data = {
  heading: "METHODOLOGY",
  list: ["Segment conducted this research using online surveys distributed by Method Communications, between April and May 2022.", "There were a total of 3,450 respondents from Australia, Brazil, Colombia, France, Germany, Italy, Japan, Mexico, Singapore, Spain, United Kingdom, and United States, with a minimum of 250 respondents from each country.", "To ensure our report incorporated both business and consumer attitudes towards personalization, we conducted two surveys.", "Our consumer survey targeted adult consumers who have purchased something online in the past 6 months. These respondents were equally split across gender.", "In addition, we also surveyed B2B and B2C business managers and above who are familiar with their company's customer experience, marketing tech, or customer data strategies."]
};
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/Methodology/Methodology.tsx


function Methodology_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Methodology = function Methodology() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBaseStyled, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
          variant: "h5",
          tag: "h4",
          children: data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
          children: data.list.map(function (text) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Li, {
              children: text
            }, text);
          })
        })]
      })
    })
  });
};

var SectionBaseStyled = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e4lprg93"
} : 0)(Section/* Wrapper */.im, "{padding:0 auto;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:80px;}}" + ( true ? "" : 0));

var Ul = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e4lprg92"
} : 0)("margin-top:40px;padding:inherit;padding-left:24px;padding-right:16px;li{:not(:first-of-type){margin:28px auto;}}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{columns:2;gap:80px;li{margin:0;break-inside:avoid-column;}}" + ( true ? "" : 0));

var Li = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e4lprg91"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.pSmall;
}, " color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[80];
}, ";" + ( true ? "" : 0));

var Methodology_StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e4lprg90"
} : 0)( true ? {
  name: "y3irtu",
  styles: "width:100%;padding:auto 80px"
} : 0);

/* harmony default export */ var Methodology_Methodology = (Methodology);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/PersonalizationAroundTheGlobe/assets/PersonalizationAroundTheGlobe@2x.png
var PersonalizationAroundTheGlobe_2x = __webpack_require__(81541);
var PersonalizationAroundTheGlobe_2x_default = /*#__PURE__*/__webpack_require__.n(PersonalizationAroundTheGlobe_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/PersonalizationAroundTheGlobe/assets/PersonalizationAroundTheGlobe.webp
var PersonalizationAroundTheGlobe = __webpack_require__(54181);
var PersonalizationAroundTheGlobe_default = /*#__PURE__*/__webpack_require__.n(PersonalizationAroundTheGlobe);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/components/PersonalizationAroundTheGlobe/assets/PersonalizationAroundTheGlobe@2x.webp
var assets_PersonalizationAroundTheGlobe_2x = __webpack_require__(57219);
var assets_PersonalizationAroundTheGlobe_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PersonalizationAroundTheGlobe_2x);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/PersonalizationAroundTheGlobe/PersonalizationAroundTheGlobeImage.tsx









var PersonalizationAroundTheGlobeImage = function PersonalizationAroundTheGlobeImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      media: theme.breakpoints.up("lg", false),
      srcSet: "".concat((PersonalizationAroundTheGlobe_default()), ", ").concat((assets_PersonalizationAroundTheGlobe_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      width: 640,
      height: 528,
      src: (PersonalizationAroundTheGlobe_2x_default()),
      alt: "Illustration: Personalization around the globe",
      loading: "lazy"
    })]
  });
};

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1orj0b50"
} : 0)("border-radius:20px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.between("md", "lg");
}, "{max-width:400px;}" + ( true ? "" : 0));

/* harmony default export */ var PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobeImage = (PersonalizationAroundTheGlobeImage);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/PersonalizationAroundTheGlobe/PersonalizationAroundTheGlobe.tsx







var PersonalizationAroundTheGlobe_copy = {
  heading: "Personalization around the globe",
  content: ["Welcome to the third annual State of Personalization Report, a global look at the latest trends in personalization, first-party data, privacy, and consumer loyalty.", "In this report, we surveyed nearly 3,500 businesses and consumers across five continents to get a pulse check of how attitudes and experiences with personalization have changed over the past 12 months.", "Read on to explore our key findings, or download the full report to get the complete picture of the trends shaping the future of personalization."]
};

var PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobe = function PersonalizationAroundTheGlobe() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonalizationAroundTheGlobe_StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h2",
        tag: "h2",
        children: PersonalizationAroundTheGlobe_copy.heading
      }), PersonalizationAroundTheGlobe_copy.content.map(function (el) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pLarge",
          tokens: {
            color: theme.palette.twilio.gray[80]
          },
          children: el
        }, el);
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobeImage, {})
    })]
  });
};

/* harmony default export */ var components_PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobe = (PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobe);

var PersonalizationAroundTheGlobe_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1o9uhvs0"
} : 0)(Section/* Contents */.AU, "{justify-content:left;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/components/RecommendedReading/RecommendedReading.tsx


function RecommendedReading_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var RecommendedReading_copy = {
  heading: "Recommended reading"
};
var cards = [{
  title: "7 Steps to Omnichannel Success",
  description: "This guide offers a firsthand look at how to build an effective omnichannel marketing strategy for your business.",
  url: "https://learn.segment.com/7-steps-to-omnichannel-success/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_7-steps-to-omnichannel-success_"
}, {
  title: "Cookies, Compliance, and Customer Data",
  description: "In this guide, we show the difference between first-party and third-party data, and how it affects marketers.",
  url: "https://learn.segment.com/cookies-compliance-customer-data/?utm_source=content&utm_medium=referral&utm_campaign=all_cnt_cookies-compliance-customer-data_"
}];

var RecommendedReading = function RecommendedReading() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecommendedReading_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        tag: "h3",
        children: RecommendedReading_copy.heading
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          sm: 2
        },
        children: cards.map(function (card) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
            href: card.url,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  children: card.title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  variant: "pLarge",
                  children: card.description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                alignment: "right",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})
              })]
            })
          }, card.title);
        })
      })
    })]
  });
};

/* harmony default export */ var RecommendedReading_RecommendedReading = (RecommendedReading);

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e116pqh11"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var RecommendedReading_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e116pqh10"
} : 0)( true ? {
  name: "1rxb0gn",
  styles: "max-width:1000px"
} : 0);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2022/assets/OgStateOfPersonalizationReport2022.png
var OgStateOfPersonalizationReport2022 = __webpack_require__(45760);
var OgStateOfPersonalizationReport2022_default = /*#__PURE__*/__webpack_require__.n(OgStateOfPersonalizationReport2022);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2022/StateOfPersonalizationReport2022.tsx















var StateOfPersonalizationReport2022 = function StateOfPersonalizationReport2022() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "2022 State of Personalization Report | Twilio Segment",
      pageDescription: "The State of Personalization report looks at how attitudes, preferences, and experiences with personalization have evolved over the past year. This report features survey data from 3,000+ businesses and consumers worldwide to explore expectations for digital experiences, data privacy, personalization, and more.",
      pageOG: (OgStateOfPersonalizationReport2022_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PersonalizationAroundTheGlobe_PersonalizationAroundTheGlobe, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindings, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Methodology_Methodology, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Gray, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_RecommendedReading, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e53ot3k1"
} : 0)( true ? "" : 0);

var Gray = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e53ot3k0"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var StateOfPersonalizationReport2022_StateOfPersonalizationReport2022 = (StateOfPersonalizationReport2022);
;// CONCATENATED MODULE: ./src/pages/state-of-personalization-report-2022/index.tsx



var state_of_personalization_report_2022_StateOfPersonalizationReport2022 = function StateOfPersonalizationReport2022() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateOfPersonalizationReport2022_StateOfPersonalizationReport2022, {});
};

/* harmony default export */ var state_of_personalization_report_2022 = (state_of_personalization_report_2022_StateOfPersonalizationReport2022);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 73770:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-of-personalization-report-2022",
      function () {
        return __webpack_require__(25216);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45760:
/***/ (function(module) {

module.exports = "/_next/static/images/OgStateOfPersonalizationReport2022-ee1e27acda25112b757f2f8bac71d30f.png";

/***/ }),

/***/ 562:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-cad8703e7286b71b2b06bb329d1a95f2.png";

/***/ }),

/***/ 96950:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend01Visual-d55541da02c1a42514a1d5d58a267584.png";

/***/ }),

/***/ 20870:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend01Visual@2x-b6f6634d1b9c3644b563a21dffcd5e69.png";

/***/ }),

/***/ 16610:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend02Visual-20e5db94baea5173b3c15bba669f9657.png";

/***/ }),

/***/ 65473:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend02Visual@2x-4024fd1ac6bdfa0ffcbf1171c20c30df.png";

/***/ }),

/***/ 54748:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend03Visual-ebc9aebd249ea8003835accead2bd2ad.png";

/***/ }),

/***/ 58827:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend03Visual@2x-b9aee13d9cb42642d08a2ff7c47c87ae.png";

/***/ }),

/***/ 47111:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend04Visual-2c7eb351bfc763ec94cc10160963fd9b.png";

/***/ }),

/***/ 44557:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend04Visual@2x-c80c71d74361fd08e2aec500df327cc8.png";

/***/ }),

/***/ 66752:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend05Visual-33f88ebff0ea08891f6d17bb3bccf31f.png";

/***/ }),

/***/ 13721:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend05Visual@2x-4978e192a8d2bba04217b3ac0ab34041.png";

/***/ }),

/***/ 81541:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationAroundTheGlobe@2x-c6c09a5dd29931a54ac2656dddf74232.png";

/***/ }),

/***/ 88958:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-5f48f082d32ba3a9387358099f02cd88.webp";

/***/ }),

/***/ 1506:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-4b73ddf7eff4a6b896249b5c640020cd.webp";

/***/ }),

/***/ 49144:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend01Visual-61a54c07078bea26cba4bd36eddbec1f.webp";

/***/ }),

/***/ 67451:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend01Visual@2x-e3c2aa6d6c1999af9ae8255956062c56.webp";

/***/ }),

/***/ 15355:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend02Visual-29ed54feea2f195862bc0cf08c028c7a.webp";

/***/ }),

/***/ 7098:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend02Visual@2x-80d7023d4e155c825fd8d31323a09e7f.webp";

/***/ }),

/***/ 94841:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend03Visual-3243c9ada3aa5aad5bc183e423f93d60.webp";

/***/ }),

/***/ 28208:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend03Visual@2x-3d888879f855edd5713f7a857afafd43.webp";

/***/ }),

/***/ 13334:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend04Visual-818e5010936513e48fa2fbb95ccfda00.webp";

/***/ }),

/***/ 50932:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend04Visual@2x-05011718f08b7c27cc230ffae495e803.webp";

/***/ }),

/***/ 48299:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend05Visual-04f8c73440563bf74b1cd37409c8a815.webp";

/***/ }),

/***/ 64440:
/***/ (function(module) {

module.exports = "/_next/static/images/Trend05Visual@2x-dc574e85aecfcf17f9141ab29d07a609.webp";

/***/ }),

/***/ 54181:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationAroundTheGlobe-b052fd4085d1a5dad5e03333db19e16b.webp";

/***/ }),

/***/ 57219:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizationAroundTheGlobe@2x-414c7013a6c0948f11dfacb581a3f1d0.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8726,7960,6012,4881,9524,9774,2888,179], function() { return __webpack_exec__(73770); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);